export function fire(..._0x1aebbb){const _0x35de70=this;return new _0x35de70(..._0x1aebbb);}